import { erpAxios } from '..';

const getApplication = async (brojZahtjeva) => {
  const { data } = await erpAxios(`/segmentation/${brojZahtjeva}`);
  return data;
};

export default getApplication;